var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGasPipeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23435 10.9238H7.53123C6.9718 10.9238 6.43527 11.1461 6.03969 11.5416C5.64411 11.9372 5.42188 12.4738 5.42188 13.0332C5.42188 13.5926 5.64411 14.1291 6.03969 14.5247C6.43527 14.9203 6.9718 15.1425 7.53123 15.1425H12.4531C13.9489 15.1444 15.4053 15.6223 16.6113 16.5072C17.8173 17.3921 18.7103 18.638 19.1608 20.0644",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9976 11.1992H9.59766",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59766 7H14.9976",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3112 20.0644C13.7986 19.6106 13.1376 19.3605 12.453 19.3612H7.5312C5.85289 19.3612 4.24332 18.6945 3.05658 17.5078C1.86983 16.321 1.20312 14.7115 1.20312 13.0332C1.20312 11.3548 1.86983 9.74527 3.05658 8.55853C4.24332 7.37178 5.85289 6.70508 7.5312 6.70508H8.23432",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5977 5.29883V12.33",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23438 5.29883V12.33",
    stroke: "#9B90A7",
    strokeWidth: 0.999992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7752 5.29883C19.0338 5.63645 19.1916 6.05286 19.2272 6.49183C19.2628 6.9308 19.1746 7.37117 18.9744 7.75346C18.7974 7.76826 18.6218 7.70891 18.4831 7.58739C18.3445 7.46588 18.2531 7.29126 18.2275 7.09881C17.9623 7.25744 17.7441 7.49578 17.5985 7.78574C17.4529 8.07571 17.386 8.40521 17.4057 8.73542C17.4058 8.99332 17.4522 9.24869 17.5424 9.48694C17.6326 9.72518 17.7647 9.94164 17.9313 10.124C18.0979 10.3063 18.2956 10.4509 18.5132 10.5495C18.7308 10.6481 18.964 10.6989 19.1995 10.6988C19.6726 10.6908 20.1243 10.4813 20.4588 10.1148C20.7934 9.74835 20.9845 9.25359 20.9917 8.73542C21.051 7.96843 20.8611 7.20314 20.4557 6.57444C20.0502 5.94574 19.455 5.494 18.7752 5.29883Z",
    stroke: "#9B90A7",
    strokeWidth: 0.749994,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasPipeline);
export default __webpack_public_path__ + "static/media/gas-pipeline.21d80052ca97efdee2828a38b4a379be.svg";
export { ForwardRef as ReactComponent };